module.exports = __webpack_public_path__ + "img/fd6524f.jpg";